import * as THREE from 'three';
import {
  BIOME_NAMES,
  BIOME_PREVIEW_ORIGINS,
  BIOME_PROFILES,
  type BiomeName,
} from '../world/biomes';

export interface EnvironmentDefinition {
  readonly id: BiomeName;
  readonly name: string;
  readonly tagline: string;
  readonly origin: Readonly<{ x: number; z: number }>;
  readonly sky: THREE.ColorRepresentation;
}

function colorValue(color: readonly [number, number, number]): number {
  return new THREE.Color(...color).getHex();
}

export const ENVIRONMENT_CATALOG: readonly EnvironmentDefinition[] = BIOME_NAMES.map((id) => {
  const profile = BIOME_PROFILES[id];
  return {
    id,
    name: profile.label,
    tagline: profile.description,
    origin: BIOME_PREVIEW_ORIGINS[id],
    sky: colorValue(profile.skyColor),
  };
});

export function getEnvironmentDefinition(id: string): EnvironmentDefinition | undefined {
  return ENVIRONMENT_CATALOG.find((environment) => environment.id === id);
}
